import type {
  SupplierRelationshipIntegrationValueCreateRequestType,
  SupplierRelationshipList_suppliersResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useSupplierRelationshipIntegrationValuesCreate = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: SupplierRelationshipIntegrationValueCreateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `supplier-relationship-integration-values`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as SupplierRelationshipList_suppliersResponseType[number],
      ),

    onSuccess: (response) => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.Integrations],
      });
      queryClient.invalidateQueries({
        queryKey: [
          business?.id,
          ServerStateKeys.SupplierRelationshipIntegrationValues,
          response.id,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [
          business?.id,
          ServerStateKeys.SupplierRelationshipIntegrationValues,
        ],
      });
    },
  });
};
